module.exports = __webpack_public_path__ + "static/media/circle-social-life.0ded66e5.svg";